import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Switch, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {toast} from 'react-toastify';
import EditPassword from '../../components/Profile/EditPassword';
import UserProfile from '../../components/Profile/UserProfile';
import CompleteProfile from '../../components/Profile/CompleteProfile';
import {userProfileUpdated} from '../../configs/messages';
import {Wrapper} from '../../components/common';

import * as userActions from '../../actions/user';

class EditProfileContainer extends Component {
  static propTypes = {
    user: PropTypes.shape({
      id: PropTypes.string,
      firstName: PropTypes.string,
      email: PropTypes.string,
      lastName: PropTypes.string,
      image: PropTypes.string,
      coins: PropTypes.shape({}).isRequired,
    }).isRequired,
    updateUser: PropTypes.func.isRequired,
    updatePassword: PropTypes.func.isRequired,
    updateProfileSuccess: PropTypes.bool.isRequired,
    updatePasswordSuccess: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const {updateProfileSuccess} = this.props;
    if (updateProfileSuccess) {
      toast.success(userProfileUpdated);
    }
  }

  onSaveUser = (data) => {
    const {updateUser} = this.props;
    updateUser(data);
  };

  onChangePassword = (data) => {
    const {updatePassword} = this.props;
    updatePassword(data);
  };

  render() {
    return (
      <Wrapper>
        <div className="cell cell_full">
          <Switch>
            <Route
              exact
              path="/profile/password"
              render={() => (
                <EditPassword {...this.props} onChangePassword={this.onChangePassword}/>
              )}
            />
            <Route
              exact
              path="/profile"
              render={() => <UserProfile {...this.props} onSaveUser={this.onSaveUser}/>}
            />
            <Route
              exact
              path="/complete-profile"
              render={() => <CompleteProfile {...this.props} onSaveUser={this.onSaveUser}/>}
            />
          </Switch>
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    user: {
      coins,
      profile, updateProfileSuccess, updatePasswordSuccess,
      treasures, availablePoints, definitions, help,
    },
  } = state;
  return {
    user: {...profile, help, coins},
    updateProfileSuccess,
    updatePasswordSuccess,
    treasures,
    userDefinitions: definitions,
    availablePoints,
  };
};

const mapDispatchToProps = dispatch => (
  {dispatch, ...bindActionCreators(userActions, dispatch)}
);

export default connect(mapStateToProps, mapDispatchToProps)(EditProfileContainer);
